import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
import axios from "axios";
var SummaryView = /** @class */ (function (_super) {
    tslib_1.__extends(SummaryView, _super);
    function SummaryView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addedToCart = null;
        _this.addToCartFailedProducts = [];
        _this.addingToCart = false;
        _this.addToCartPopupVisible = false;
        _this.addToFavoritesPopupVisible = false;
        _this.codeWasCopied = false;
        _this.codeWasCopiedTimer = null;
        _this.codeWasSentToVertex = false;
        _this.codeWasSentToVertexTimer = null;
        _this.addingToFavorites = false;
        _this.addedToFavorites = null;
        _this.sendEmailPopupVisible = false;
        _this.addNewProductPopupVisible = false;
        _this.emailSenderName = null;
        _this.emailRecipient = null;
        _this.emailMessage = null;
        _this.emailOrderName = null;
        _this.emailOrderNumber = null;
        _this.emailOrderDeliveryDate = null;
        _this.invalidEmailSender = false;
        _this.invalidEmailRecipient = false;
        _this.emailSent = false;
        _this.errorSendingEmail = false;
        _this.sendingEmailThrottled = false;
        _this.sendingEmail = false;
        _this.isProshopUser = false;
        _this.codeIndex = 0;
        return _this;
    }
    SummaryView.prototype.removeProduct = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm(this.$ui.t("removeProductConfirm")))
                            return [2 /*return*/];
                        return [4 /*yield*/, this.$cart.removeProductFromCart(product)];
                    case 1:
                        _a.sent();
                        if (this.$cart.cartProducts.length == 0) {
                            this.$router.push("/");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.addProduct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$cart.addCurrentDesignToCart()];
                    case 1:
                        _a.sent();
                        this.$cart.resetState();
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.addWorktop = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addProduct()];
                    case 1:
                        _a.sent();
                        this.$router.replace("/worktop");
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.addBackpanel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addProduct()];
                    case 1:
                        _a.sent();
                        this.$router.replace("/backpanel");
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.mounted = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$cart.populateSummary()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.trackDesign()];
                    case 2:
                        _a.sent();
                        this.$watch("sendEmailPopupVisible", this.popupVisibilitychanged);
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.trackDesign = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bodyFormData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bodyFormData = new FormData();
                        bodyFormData.append("Code", this.$cart.planCode);
                        bodyFormData.append("IsProshopUser", this.$state.isProshopUser.toString());
                        bodyFormData.append("IsProshop", this.$state.proshop.toString());
                        bodyFormData.append("IsFusion", this.$state.fusion.toString());
                        bodyFormData.append("IsVertex", this.$state.vertex.toString());
                        return [4 /*yield*/, axios.post("LogDesign", bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SummaryView.prototype, "vertexCode", {
        get: function () {
            var product = this.$cart.products[0];
            var code = product.code;
            if (!this.$state.disableAccessories && this.$state.accessories && this.$state.accessories.length > 0) {
                var accessories = this.$state.accessories.filter(function (a) { return a != "trap"; });
                if (accessories && accessories.length > 0)
                    code += "|" + accessories.reduce(function (a, s) { return a + "|" + s; });
            }
            return code;
        },
        enumerable: true,
        configurable: true
    });
    SummaryView.prototype.trackSavePdf = function () {
        if (!this.$ga)
            return;
        this.$ga.event({
            eventCategory: 'DesignerAction',
            eventAction: 'savePdf',
            eventLabel: this.$cart.planCode,
            eventValue: 1
        });
    };
    SummaryView.prototype.sendToVertex = function () {
        var codeInput = this.$refs.vertexCode;
        codeInput.select();
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        this.codeWasSentToVertex = true;
        clearTimeout(this.codeWasSentToVertexTimer);
        var self = this;
        this.codeWasSentToVertexTimer = setTimeout(function () { return self.codeWasSentToVertex = false; }, 3000);
    };
    SummaryView.prototype.sendToFusion = function () {
        var product = this.$cart.products[0];
        var planCode = this.$cart.planCode == product.code ? "" : this.$cart.planCode;
        var accessories = product.accessories && product.accessories.length > 0
            ? product.accessories.map(function (a) { return a.code; }).filter(function (a) { return a != "trap"; }).join(",")
            : "";
        window.external.UtilizeCodeAndPrice(product.code, product.price.toString(), planCode, accessories);
        if (this.$ga) {
            this.$ga.event({
                eventCategory: 'DesignerAction',
                eventAction: 'sendToFusion',
                eventLabel: this.$cart.planCode,
                eventValue: 1
            });
        }
    };
    SummaryView.prototype.popupVisibilitychanged = function () {
        if (!this.sendEmailPopupVisible) {
            this.emailSent = false;
            this.errorSendingEmail = false;
            this.sendingEmailThrottled = false;
        }
    };
    Object.defineProperty(SummaryView.prototype, "summaryColumnRowSpan", {
        get: function () {
            return this.$ui.isTabletView ? 1 : 3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryView.prototype, "emailShowOrderFields", {
        get: function () {
            return this.emailRecipient && this.emailRecipient.trim().endsWith("@stala.com");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryView.prototype, "stateDetails", {
        get: function () {
            var properties = "";
            for (var stateProperty in this.$state) {
                properties += stateProperty + ":" + this.$state[stateProperty] + "<br />";
            }
            return properties;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryView.prototype, "backLink", {
        get: function () {
            if (this.$state.mode == "backpanel")
                return "backpanel-material";
            return this.$state.disableAccessories
                ? "hobcutout"
                : "accessories";
        },
        enumerable: true,
        configurable: true
    });
    SummaryView.prototype.copyCode = function () {
        var codeInput = this.$refs.planCode;
        codeInput.select();
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        if (this.$state.vertex)
            return;
        this.codeWasCopied = true;
        clearTimeout(this.codeWasCopiedTimer);
        var self = this;
        this.codeWasCopiedTimer = setTimeout(function () { return self.codeWasCopied = false; }, 3000);
    };
    Object.defineProperty(SummaryView.prototype, "pdfLink", {
        get: function () {
            return "/designer/pdf/?planCode=" + this.$cart.planCode + "&language=" + this.$ui.language;
        },
        enumerable: true,
        configurable: true
    });
    SummaryView.prototype.getCartFailureMessage = function () {
        return this.$ui.t('addedToCartFailedText')
            + " "
            + (this.addToCartFailedProducts && this.addToCartFailedProducts.length > 0 ? this.addToCartFailedProducts.reduce(function (acc, p) { return acc + "," + p; }) : "");
    };
    SummaryView.prototype.addToProshopFavorites = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bodyFormData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.addingToFavorites)
                            return [2 /*return*/];
                        this.addToCartFailedProducts = [];
                        bodyFormData = new FormData();
                        bodyFormData.append("planCode", this.$cart.planCode);
                        this.addingToFavorites = true;
                        return [4 /*yield*/, axios.post("AddPlanToFavorites", bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
                                _this.addedToFavorites = response.data;
                                _this.addingToFavorites = false;
                                _this.addToFavoritesPopupVisible = true;
                                if (_this.$ga) {
                                    _this.$ga.event({
                                        eventCategory: 'DesignerAction',
                                        eventAction: 'addToFavorites',
                                        eventLabel: _this.$cart.planCode,
                                        eventValue: 1
                                    });
                                }
                            }).catch(function (error) {
                                _this.addedToFavorites = false;
                                _this.addingToFavorites = false;
                                _this.addToFavoritesPopupVisible = true;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SummaryView.prototype, "invalidEmailOrderName", {
        get: function () {
            return !this.emailOrderName || !this.emailShowOrderFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryView.prototype, "invalidEmailOrderNumber", {
        get: function () {
            return !this.emailOrderNumber || !this.emailShowOrderFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryView.prototype, "invalidEmailOrderDeliveryDate", {
        get: function () {
            return !this.emailOrderDeliveryDate || !this.emailShowOrderFields;
        },
        enumerable: true,
        configurable: true
    });
    SummaryView.prototype.addToStoreCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bodyFormData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.addingToCart)
                            return [2 /*return*/];
                        this.addToCartFailedProducts = [];
                        bodyFormData = new FormData();
                        bodyFormData.append("planCode", this.$cart.planCode);
                        bodyFormData.append("language", this.$ui.language);
                        this.addingToCart = true;
                        return [4 /*yield*/, axios.post("AddPlanToStoreCart", bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
                                _this.addedToCart = response.data.success;
                                _this.addToCartFailedProducts = response.data.failedProducts;
                                _this.addingToCart = false;
                                _this.addToCartPopupVisible = true;
                                if (_this.$ga) {
                                    _this.$ga.event({
                                        eventCategory: 'DesignerAction',
                                        eventAction: 'addToCart',
                                        eventLabel: _this.$cart.planCode,
                                        eventValue: 1
                                    });
                                }
                                if (window.parent) {
                                    window.parent.postMessage("cartRefresh", "*");
                                }
                                if ((!window.parent || window.parent == window) && _this.$configuration.checkoutUrl) {
                                    _this.$ui.exitConfirmed = true;
                                    _this.$state.dirty = false;
                                    window.location.href = _this.$configuration.checkoutUrl;
                                }
                            }).catch(function (error) {
                                _this.addedToCart = false;
                                _this.addingToCart = false;
                                _this.addToCartPopupVisible = true;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.addToProshopCart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bodyFormData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.addingToCart)
                            return [2 /*return*/];
                        this.addToCartFailedProducts = [];
                        bodyFormData = new FormData();
                        bodyFormData.append("planCode", this.$cart.planCode);
                        this.addingToCart = true;
                        return [4 /*yield*/, axios.post("AddPlanToCart", bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
                                _this.addedToCart = response.data.success;
                                _this.addToCartFailedProducts = response.data.failedProducts;
                                _this.addingToCart = false;
                                _this.addToCartPopupVisible = true;
                                if (_this.$ga) {
                                    _this.$ga.event({
                                        eventCategory: 'DesignerAction',
                                        eventAction: 'addToCart',
                                        eventLabel: _this.$cart.planCode,
                                        eventValue: 1
                                    });
                                }
                                if (window.parent) {
                                    window.parent.postMessage("cartRefresh", "*");
                                }
                            }).catch(function (error) {
                                _this.addedToCart = false;
                                _this.addingToCart = false;
                                _this.addToCartPopupVisible = true;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.sendEmail = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var emailRegexp, isValidEmailAddress, requiredFields, verificationToken, bodyFormData, url, emailSent;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.sendingEmail)
                            return [2 /*return*/];
                        this.sendingEmail = true;
                        emailRegexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                        if (!this.emailSenderName) {
                            this.invalidEmailSender = true;
                            this.sendingEmail = false;
                            return [2 /*return*/];
                        }
                        this.invalidEmailSender = false;
                        isValidEmailAddress = emailRegexp.test(this.emailRecipient);
                        if (!isValidEmailAddress) {
                            this.invalidEmailRecipient = true;
                            this.sendingEmail = false;
                            return [2 /*return*/];
                        }
                        if (this.emailShowOrderFields) {
                            requiredFields = [this.emailOrderName, this.emailOrderNumber, this.emailOrderDeliveryDate];
                            if (requiredFields.filter(function (f) { return !f || f.length <= 0; }).length > 0) {
                                this.sendingEmail = false;
                                return [2 /*return*/];
                            }
                        }
                        this.invalidEmailRecipient = false;
                        verificationToken = document.querySelector('input[name="__RequestVerificationToken"]');
                        bodyFormData = new FormData();
                        bodyFormData.append("sender", this.emailSenderName);
                        bodyFormData.append("message", this.emailMessage);
                        bodyFormData.append("email", this.emailRecipient);
                        bodyFormData.append("code", this.$cart.planCode);
                        bodyFormData.append("__RequestVerificationToken", verificationToken.value);
                        if (this.emailShowOrderFields) {
                            bodyFormData.append("orderName", this.emailOrderName);
                            bodyFormData.append("orderNumber", this.emailOrderNumber);
                            bodyFormData.append("orderDeliveryDate", this.emailOrderDeliveryDate);
                        }
                        url = "email?language=" + this.$ui.language;
                        emailSent = null;
                        return [4 /*yield*/, axios.post(url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
                                _this.emailSent = response.data;
                                _this.sendingEmail = false;
                                if (!response.data) {
                                    _this.errorSendingEmail = true;
                                }
                                else {
                                    _this.emailSenderName = null;
                                    _this.emailRecipient = null;
                                    _this.emailMessage = null;
                                }
                                if (_this.$ga) {
                                    _this.$ga.event({
                                        eventCategory: 'DesignerAction',
                                        eventAction: 'email',
                                        eventLabel: _this.$cart.planCode,
                                        eventValue: 1
                                    });
                                }
                            }).catch(function (error) {
                                _this.sendingEmail = false;
                                //Sending emails is being throttled
                                if (error.response.status == 409) {
                                    _this.sendingEmailThrottled = true;
                                }
                                else {
                                    _this.errorSendingEmail = true;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SummaryView.prototype.getCodePart = function (length, title) {
        var baseString = title + ": ";
        if (this.$cart.currentDesignerCode.length < this.codeIndex + length)
            return baseString + "--";
        var ret = baseString + this.$cart.currentDesignerCode.substring(this.codeIndex, this.codeIndex + length) + " [" + (this.codeIndex + 1) + " - " + (this.codeIndex + length) + "]";
        this.codeIndex = this.codeIndex + length;
        return ret;
    };
    Object.defineProperty(SummaryView.prototype, "codeSummary", {
        get: function () {
            var parts = [];
            this.codeIndex = 0;
            parts.push(this.getCodePart(1, "Allas"));
            parts.push(this.getCodePart(4, "Kannen pituus"));
            parts.push(this.getCodePart(1, "Kannen korkeus"));
            parts.push(this.getCodePart(1, "Kätisyys"));
            parts.push(this.getCodePart(1, "Reunaprofiili"));
            parts.push(this.getCodePart(4, "S-mitta"));
            parts.push(this.getCodePart(1, "Kannen leveys"));
            parts.push(this.getCodePart(1, "Hanareikä"));
            parts.push(this.getCodePart(1, "Lisäreikä"));
            parts.push(this.getCodePart(1, "Materiaali"));
            parts.push(this.getCodePart(1, "Vesilukko"));
            parts.push(this.getCodePart(1, "Liesiaukko"));
            parts.push(this.getCodePart(4, "Liesiaukon pituus"));
            parts.push(this.getCodePart(3, "Liesiaukon leveys"));
            parts.push(this.getCodePart(1, "Liesiaukon nurkan säde"));
            parts.push(this.getCodePart(4, "Liesiaukon sijainti x"));
            parts.push(this.getCodePart(2, "Liesiaukon sijainti y"));
            parts.push(this.getCodePart(1, "M1 rakenne"));
            parts.push(this.getCodePart(2, "Grafiikka"));
            parts.push("Lisävarusteet: " + this.$state.accessories);
            this.codeIndex = 0;
            return parts;
        },
        enumerable: true,
        configurable: true
    });
    SummaryView = tslib_1.__decorate([
        Component
    ], SummaryView);
    return SummaryView;
}(Vue));
export default SummaryView;
